export default __webpack_public_path__ + "static/media/select-bet-3.3766b74f.mp3";